import "./js/wc-product-gallery/wc-product-gallery.js";
import "./js/zoom-init.js";
import "./style.scss";
